import {useCallback} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import '../../assets/styles/payment/publicPages.scss';
import usePageMeta from '../../services/page-meta';
import {resolveLocalePrefix, usePaymentPayload} from './helpers';

export default function CashBackPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('meta.paymentCashBack.title', t('payment.cashBack.header')),
        description: t('meta.paymentCashBack.description', t('app.description')),
        keywords: t('meta.paymentCashBack.keywords', t('app.keywords')),
    });

    const history = useHistory();
    const location = useLocation();
    const {payload, isLoading} = usePaymentPayload('/api/v1/payment/cashback');

    const handleGoBack = useCallback((event) => {
        event.preventDefault();

        if (window.history.length > 1) {
            history.goBack();
            return;
        }

        const localePrefix = resolveLocalePrefix(location.pathname);
        history.push(`${localePrefix}/`);
    }, [history, location.pathname]);

    if (isLoading || payload?.state !== 'active') {
        return <section className="payment-support-page payment-support-section" />;
    }

    return (
        <div className="payment-support-page">
            <section className="payment-support-section">
                <div className="container">
                    <div className="payment-header flex-center">
                        <div className="link-block">
                            <button type="button" className="payment-back-btn js-go-back" onClick={handleGoBack}>
                                {t('app.back')}
                            </button>
                        </div>
                        <h1>{t('payment.cashBack.header')}</h1>
                    </div>
                    <div className="wrap">
                        <p dangerouslySetInnerHTML={{__html: t('payment.cashBack.contactUs')}} />
                        <h6>{t('payment.cashBack.cancelAndRefund')}</h6>
                        <div dangerouslySetInnerHTML={{__html: t('payment.cashBack.cancelAndRefundList')}} />
                        <h6>{t('payment.cashBack.refundPolicy')}</h6>
                        <div dangerouslySetInnerHTML={{__html: t('payment.cashBack.refundPolicyList')}} />
                        <h6>{t('payment.cashBack.refundMethods')}</h6>
                        <p>{t('payment.cashBack.refundMethodsCaption')}</p>
                        <p>{t('payment.cashBack.notPublic')}</p>
                    </div>
                </div>
            </section>
        </div>
    );
}
